import React, { useState, useEffect, useRef } from 'react';
import { arrayUnion, doc, getDoc, writeBatch } from "firebase/firestore";
import { TbMailbox } from 'react-icons/tb';

export const CheckInvitesDialog = ({ inviteData, setAppendedInvite, setDocData, setEventParticipants, userEmail, db }) => {

    const invitationDialogRef = useRef();
    const [mapInvites, setMapInvites] = useState([]);
    const message = {
        info: "No new invitations available!",
        success: "You have been successfully added to the event list with name:",
    };
    const [inviteVal, setInviteVal] = useState("");
    const handleSelect = (e) => {
        let val = e.target.value;
        setInviteVal(val);
    }

    useEffect(() => {
        // console.log('inviteData\t', inviteData);
        if (inviteData.length) {
            setMapInvites(inviteData.filter(i => !i.acceptedInvite === true));
        }
    }, [inviteData])

    const handleCheckEventClick = () => {
        invitationDialogRef.current.showModal();
    }

    const handleInvitationSubmit = async () => {
        if (!inviteVal) return;

        const eventConfirmedId = inviteVal;
        const inviteRef = doc(db, 'inviteInboxes', userEmail, 'invites', eventConfirmedId);
        const eventRef = doc(db, 'events', eventConfirmedId);

        try {
            const batch = writeBatch(db);
            batch.update(eventRef, {
                eventParticipants: arrayUnion(userEmail),
            });
            batch.update(inviteRef, {
                acceptedInvite: true,
            });
            await batch.commit();

            const docSnap = await getDoc(eventRef);
            if (docSnap.exists()) {
                setEventParticipants(docSnap.data().eventParticipants);
                setAppendedInvite(docSnap.data());
                setDocData(prev => [...prev, {id: docSnap.id, ...docSnap.data()}]);
            }

        } catch (error) {
            console.error(error);
        }
    }

    return (
        <>
            <div className='chkInvHide my-2 w-fit'>Check Event Invite
                <div className='hover:cursor-pointer'
                    onClick={handleCheckEventClick}>
                        <TbMailbox className='text-primary hover:text-secondary hover:scale-[115%] hover:duration-200 ease-in-out' size={'35px'} />
                </div>
            </div>
            {/* <button className="btn" onClick={()=>document.getElementById('invitationDialog').showModal()}>open modal</button> */}
                <dialog ref={invitationDialogRef} className="modal">
                    {mapInvites?.length ?
                        <div className="modal-box">
                            <h3 className="font-bold text-lg">Invitations:</h3>
                            <select className="select select-bordered w-full max-w-xs" value={inviteVal} onChange={handleSelect}>
                                <option value="" disabled>Select an invitation...</option>
                                {mapInvites?.map((invite) => {
                                    return (
                                        <option key={invite.eventId} value={invite.eventId}>
                                            Event: {invite?.event} | Invited By:{invite?.invitedBy}
                                        </option>
                                    );
                                })}
                            </select>
                            <div className="modal-action">
                                <form method="dialog">
                                    <button className="btn" onClick={handleInvitationSubmit}>Accept</button>
                                    <button className="btn">Close</button>
                                </form>
                            </div>
                        </div>
                    : <div className="modal-box">
                        <h3 className="font-bold text-lg">{message.info}</h3>
                        <form method='dialog'>
                            <button className='btn'>Close</button>
                        </form>
                      </div>
                    }
                </dialog>
        </>
    );
}
